"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIcon = void 0;
var _ThemeContext = require("../contexts/ThemeContext");
var getIcon = (iconName, theme) => {
  if (!iconName) return undefined;
  try {
    switch (theme) {
      case _ThemeContext.THEMES.KOODO:
        return require("@telus-uds/palette-koodo/build/web/icons/".concat(iconName, ".js"));
      case _ThemeContext.THEMES.PUBLIC:
        return require("@telus-uds/palette-public-mobile/build/web/icons/".concat(iconName, ".js"));
      case _ThemeContext.THEMES.ALLIUM:
      default:
        return require("@telus-uds/palette-allium/build/web/icons/".concat(iconName, ".js"));
    }
  } catch (e) {
    console.error('getIcon Exception', e.message);
    return undefined;
  }
};
exports.getIcon = getIcon;